// Small markdown renderer shared by advisor chat + daily brief
// Supports: ## headings, ### subheadings, **bold**, *italic*, `code`, `- item` lists, plain paragraphs.
function renderInline(text) {
  // escape then re-insert
  const parts = [];
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g;
  let last = 0; let m; let i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const t = m[0];
    if (t.startsWith("**")) parts.push(<strong key={`b${i++}`} className="font-semibold text-slate-900">{t.slice(2, -2)}</strong>);
    else if (t.startsWith("`")) parts.push(<code key={`c${i++}`} className="rounded bg-slate-100 px-1 py-0.5 text-[12px] font-mono text-slate-800">{t.slice(1, -1)}</code>);
    else parts.push(<em key={`i${i++}`} className="italic">{t.slice(1, -1)}</em>);
    last = m.index + t.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export function Markdown({ content }) {
  if (!content) return null;
  const lines = content.split("\n");
  const out = [];
  let i = 0;
  while (i < lines.length) {
    const l = lines[i];
    if (/^##\s/.test(l)) {
      out.push(<h2 key={i} className="mt-5 mb-2 text-base font-bold text-slate-900 flex items-center gap-1.5">{renderInline(l.replace(/^##\s/, ""))}</h2>);
      i++; continue;
    }
    if (/^###\s/.test(l)) {
      out.push(<h3 key={i} className="mt-4 mb-1.5 text-sm font-semibold text-slate-800">{renderInline(l.replace(/^###\s/, ""))}</h3>);
      i++; continue;
    }
    if (/^\s*[-•]\s/.test(l)) {
      const bullets = [];
      while (i < lines.length && /^\s*[-•]\s/.test(lines[i])) {
        bullets.push(lines[i].replace(/^\s*[-•]\s/, ""));
        i++;
      }
      out.push(
        <ul key={`u${i}`} className="list-disc ml-5 space-y-1 text-sm text-slate-700">
          {bullets.map((b, k) => <li key={k}>{renderInline(b)}</li>)}
        </ul>
      );
      continue;
    }
    if (l.trim() === "") { out.push(<div key={i} className="h-1.5" />); i++; continue; }
    out.push(<p key={i} className="text-sm text-slate-700 leading-relaxed">{renderInline(l)}</p>);
    i++;
  }
  return <div className="space-y-1">{out}</div>;
}
